import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';
import Link from 'shared/components/Link';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Nav.css';

class Nav extends React.Component {
  static propTypes = {
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        disabled: PropTypes.bool,
        href: PropTypes.string,
        slug: PropTypes.string,
      }),
    ).isRequired,
    activeTabSlug: PropTypes.string.isRequired,
    onTabChange: PropTypes.func.isRequired,
  };

  render() {
    const { tabs, activeTabSlug, onTabChange } = this.props;

    return (
      <div className={s.root}>
        <ul className={s.nav}>
          {tabs.map(
            tab =>
              // eslint-disable-next-line no-prototype-builtins
              tab.hasOwnProperty('href')
                ? <li key={tab.title} className={cx({ [s.disabled]: !tab.href })}>
                    <Link className={cx(s.link, { [s.active]: !tab.href })} to={tab.href}>
                      <FormattedMessage id={tab.title} />
                    </Link>
                  </li>
                : <li
                    key={tab.title}
                    className={cx({
                      [s.disabled]: tab.disabled,
                      [s.active]: activeTabSlug === tab.slug,
                    })}
                    onClick={tab.disabled ? undefined : () => onTabChange(tab.slug)}
                  >
                    <span className={s.link}>
                      <FormattedMessage id={tab.title} />
                    </span>
                  </li>,
          )}
        </ul>
      </div>
    );

    // return (
    //   <div className={s.root}>
    //     <ul className={s.nav}>
    //       <li className={s.active} onClick={onBaseClick}>
    //         <FormattedMessage id="Объявление" />
    //       </li>
    //       <li className={s.disabled}>
    //         <Link className={cx(s.link)} to="#">
    //           <FormattedMessage id="Характеристики" />
    //         </Link>
    //       </li>
    //       <li className={s.disabled}>
    //         <Link className={cx(s.link)} to="#">
    //           <FormattedMessage id="Отзывы" />
    //         </Link>
    //       </li>
    //       <li className={s.active} onClick={onTestDrivesClick}>
    //         <FormattedMessage id="Тест-драйвы" className={s.link} />
    //       </li>
    //       <li className={cx({ [s.disabled]: !sparesLink })}>
    //         <Link className={cx(s.link, { [s.active]: !sparesLink })} to={sparesLink}>
    //           <FormattedMessage id="Запчасти" />
    //         </Link>
    //       </li>
    //     </ul>
    //   </div>
    // );
  }
}

export default withStyles(s)(Nav);



// WEBPACK FOOTER //
// ./src/desktop/routes/advert/components/Nav/Nav.js